import styled from "styled-components";

export const RatingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border: 1px solid #ddd;
  border-radius: 25px;
  padding: 16px;
`;

export const CacheFormWrapper = styled.div`
  border: 1px solid #dedede;
  padding: 16px;
`;

export const CacheFormContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
`;

export const CacheInputWrapper = styled.div`
  height: 50%;
  margin: 15px 0;
`;
